import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ExtraccionistaFilterComponent } from "./extraccionista-filter/extraccionista-filter.component";
import { ExtraccionistaSearchComponent } from "./extraccionista-search/extraccionista-search.component";
import { AppMaterialModule } from "../../app.material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared.module";
import { PatientAutocompleteModule } from "../autocomplete/patient/patient-autocomplete.module";
import { ExtraccionistaMedicalService } from "../../services/extraccionista-medical-service/extraccionista-medical-service.service";
import { DataService } from "../../services/data.service";
import { HttpClient } from "@angular/common/http";
import { NotificationToastService } from "../../services/notification-toast.service";
import { ExtraccionistaWizardComponent } from "./extraccionista-wizard/extraccionista-wizard.component";
import { PipesModule } from "src/app/pipes/pipes.module";
import { ControlsModule } from "../controls/controls.module";

@NgModule({
  declarations: [
    ExtraccionistaFilterComponent,
    ExtraccionistaSearchComponent,
    ExtraccionistaWizardComponent
  ],
  providers: [
    ExtraccionistaMedicalService,
    DataService,
    HttpClient,
    NotificationToastService,
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PatientAutocompleteModule,
    PipesModule,
    ControlsModule
  ],
})
export class ExtraccionistaModule {}
